import { render, staticRenderFns } from "./SeismographPrincipleViz.vue?vue&type=template&id=ff5db050&scoped=true"
import script from "./SeismographPrincipleViz.vue?vue&type=script&lang=js"
export * from "./SeismographPrincipleViz.vue?vue&type=script&lang=js"
import style0 from "./SeismographPrincipleViz.vue?vue&type=style&index=0&id=ff5db050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5db050",
  null
  
)

export default component.exports